import React, { useState } from 'react';
import { PDF_QR_JS, PDF_JS } from 'pdf-qr';
import { Button, Form, Row, Col, Container } from 'react-bootstrap';
//import { AiOutlineUpload } from 'react-icons/ai';
import Spinner from 'react-bootstrap/Spinner';
import Codifica_del_QR_nella_pagina from "./qrcode_X1_codifica_qr.jsx";
import axios from 'axios'

PDF_JS.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDF_JS.version}/pdf.worker.min.js`;



async function post_pdf({ file_blobbato} , lista_qrdata) {
    console.log('77777777777777777777 KERASE');

// toolmemo difficilissimo
    const formData = new FormData();
    formData.append("file_blobbato", file_blobbato)
    formData.append("lista_qrdata", JSON.stringify(lista_qrdata))

    let descrizione = 'a'
    let tipologia_documento = 'a'
    console.log('8888888888888888  KERASE');
    console.log(descrizione);

  //    formData.append("descrizione", descrizione)
    const result = await axios.post('/qr_code/pdf_qr_da_codificare/' + descrizione + '/' + tipologia_documento, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
//    const result = await axios.post('/qr_code/prova' )
    console.log('CCCCCCCCCCCCCCCCCCCCCCCCCCCCC  tornato nel front end')

    console.log(result)
    return result.data
}

export default function App() {
  const [lista_qrData, SET_QR_Data] = useState([]);
  const [show_spinner, SET_show_spinner] = useState(false);
  const [file, setFile] = useState()
     

  const callback = function (result) {
    // console.log(result);
    if (result.success === true) {

    console.log('11111111111111111');
    console.log(result.codesDetailed);
    SET_QR_Data(result.codesDetailed)
    SET_show_spinner (false)     
     
    } else console.log(result.message);
  };


  const configs = {
    scale: {
      once: false,
      value: 1,
      start: 0.2,
      step: 0.2,
      stop: 2,
    },
    resultOpts: {
      singleCodeInPage: true,
      multiCodesInPage: false,
      maxCodesInPage: 1,
    },
    improve: true,
    jsQR: {},
  };

  async function uploadFiles(e) {
    e.preventDefault()
    SET_show_spinner (true) 
    let input_file = e.target;
    console.log(e);
    PDF_QR_JS.decodeDocument(input_file, configs, callback);
    setFile(e.target.files[0])
//    SET_show_spinner (false) 

  }

  const parsedJson = (data) => {
    JSON.parse(data, function (key, value) {
      if (value) return value.toString();
    });
  };

  const submit = async event => {
      console.log('5555555555555555555555555555555555555555 KERASE');
      event.preventDefault()
      SET_show_spinner (true)     
      let result
      result = await post_pdf({ file_blobbato: file }, lista_qrData)
  }


  return (
    <Container fluid="xxl">
        {/* idroslab  caricamento di un file*/}

        <Form onSubmit={submit}>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Seleziona un file pdf da caricare</Form.Label>
                    <Form.Control type="file" onChange={(e) => uploadFiles(e)} accept="application/pdf"/>
                </Form.Group>
                {show_spinner  && <Spinner animation="border" role="status">
                       <span className="visually-hidden">Loading...</span>
                </Spinner>}
                

        {lista_qrData.map(function (item1, index2) {
        {
            return <div>
                <Row>
                    <small> {item1.code != '' && <> <Col>{item1.code}</Col></>} </small>
                </Row>
                <Row> 
                    <Col><Codifica_del_QR_nella_pagina qr_passato={item1} index ={index2} 
                                                       lista_qrData ={lista_qrData}
                                                       SET_QR_Data={SET_QR_Data} /> </Col>
                </Row>
            </div>
        }
        })
        }
    <div className="d-flex flex-row-reverse bd-highlight">
      {true && <Button variant="primary" type="submit" disabled={(Array.isArray(lista_qrData) && lista_qrData.length == 0)} >
                          Carica
                        </Button>}   
      
      </div>
    </Form>

    </Container>
  );
}